import { useState, useEffect } from "react";
import { Drawer } from "antd";
import MDTypography from "components/MDTypography";
import MDBox from "components/MDBox";
import { MaterialReactTable } from "material-react-table";
import { Card } from "@mui/material";
import Loader from "components/custom/Loader";
import { useMaterialUIController } from "context";
import Icon from "@mui/material/Icon";
import { useNavigate } from "react-router-dom";
import { convertUTCtoDubai } from "utils/Constant";
const DashboardDrawer = ({ title, open, onClose, rowData: propRowData, isLoading }) => {

  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [rowData, setRowData] = useState([]);
  const navigate = useNavigate();


  useEffect(() => {
    if (open) {
      setRowData(propRowData);
    }
  }, [open, propRowData]);
  const handleClose = () => {
    setRowData([]);
    onClose();
  };


  let columns = [
    {
      header: "Charger ID",
      accessorKey: "chargerId",
      size: 220,
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
      Cell: ({ row }) => {
        const handleClick = () => {
          navigate("/charger/view", {
            state: {
              charger_id: row?.original?.chargerId,
              connectorId: row?.original?.connectorId,
            },
          });
        };

        return (
          <span
            onClick={handleClick}
            style={{
              color: "#1E88E5",
              cursor: "pointer",
              textDecoration: "underline",
            }}
          >
            {row?.original?.chargerId}
          </span>
        );
      },
    },
    {
      header: "Charger Name",
      accessorKey: "chargerName",
      size: 250,
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
    },
    {
      header: "Connector ID",
      accessorKey: "connectorId",
      size: 240,
      muiTableHeadCellProps: { align: "center" },
      muiTableBodyCellProps: { align: "center" },
    },
    {
      header: "Location",
      size: 210,
      muiTableHeadCellProps: {
        align: "center",
      },
      muiTableBodyCellProps: {
        align: "center",
      },
      accessorKey: "locationName",
      align: "center",
    },
    // {
    //   header: "Energy Disperse",
    //   size: 260,
    //   muiTableHeadCellProps: {
    //     align: "center",
    //   },
    //   muiTableBodyCellProps: {
    //     align: "center",
    //   },
    //   accessorKey: "energyCons",
    //   align: "center",
    // },
    {
      header: "Last Ping", accessorKey: "lastPing", align: "center",
      size: 230,
      muiTableHeadCellProps: {
        align: 'center',
      },
      muiTableBodyCellProps: {
        align: 'center',
      },
      Cell: ({ cell }) => {
        return convertUTCtoDubai(cell.getValue());
      },
    },
  ];

  const sessionIdColumn = {
    header: "Session ID",
    accessorKey: "sessionId",
    muiTableHeadCellProps: { align: "center" },
    muiTableBodyCellProps: { align: "center" },
    Cell: ({ row }) => {
      const handleClick = () => {
        navigate("/session", {
          state: {
            _id: row?.original?.sessionId,
            charger_id: row?.original?.charger_id,
            chargerName: row?.original?.chargerName
          },
        });
      };
      return (

        <span
          onClick={handleClick}
          style={{
            color: "#1E88E5",
            cursor: "pointer",
            textDecoration: "underline",
          }}
        >
          {row?.original?.sessionId}
        </span>
      );
    },
  };

  const startedAtColumn = {
    header: "Started At",
    accessorKey: "startedAt",
    muiTableHeadCellProps: { align: "center" },
    muiTableBodyCellProps: { align: "center" },
    Cell: ({ cell }) => convertUTCtoDubai(cell.getValue()),
  };


  if (title === "Live Session") {
    // Insert SessionID before ChargerID → position 0
    columns.splice(0, 0, sessionIdColumn);

    // Insert startedAt before Last Ping
    const lastPingIndex = columns.findIndex(col => col.accessorKey === "lastPing");
    if (lastPingIndex !== -1) {
      columns.splice(lastPingIndex, 0, startedAtColumn);
    }
  }


  return (
    <Drawer
      placement="right"
      open={open}
      onClose={handleClose}
      width={900}
      closable={false}
      title={null}
      headerStyle={{ display: "none" }}
      bodyStyle={{
        padding: 0,
        backgroundColor: darkMode ? "rgb(39 45 65)" : "#ffffff",
      }}
    >
      <MDBox
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        px={2}
        py={1}
        sx={{
          borderBottom: darkMode
            ? "1px solid rgba(255,255,255,0.2)"
            : "1px solid #e0e0e0",
          backgroundColor: darkMode ? "rgb(39 45 65)" : "#ffffff",
        }}
      >
        <MDTypography
          variant="h6"
          fontWeight="medium"
          color={darkMode ? "white" : "dark"}
        >
          {title}
        </MDTypography>

        <Icon
          onClick={handleClose}
          sx={{
            cursor: "pointer",
            fontSize: "20px",
            color: darkMode ? "#ffffff" : "#000000",
          }}
        >
          close
        </Icon>
      </MDBox>

      <Card style={{ backgroundColor: darkMode ? "#344767" : "#ffffff" }}>
        {isLoading ? (
          <Loader />
        ) : (
          <MaterialReactTable
            columns={columns}
            data={rowData}
            initialState={{ showColumnFilters: false, density: "compact" }}
            enableColumnResizing
            columnResizeMode="onChange"
            defaultColumn={{
              minSize: 150,
              size: 200,
              maxSize: 400,
            }}
            muiTableProps={{
              size: "small",
              sx: darkMode
                ? {
                  backgroundColor: "#202940",
                  color: "#ffffff",
                  "& .MuiTableCell-root": {
                    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                    fontSize: "13px",
                    fontWeight: 500,
                    lineHeight: "16px",
                    color: "#ffffff",
                  },
                  "& .MuiTableRow-root": {
                    height: "36px",
                    "&:hover": {
                      backgroundColor: "rgba(255,255,255,0.02)",
                    },
                  },
                  "& .MuiTableHead-root .MuiTableCell-root": {
                    fontSize: "13px",
                    lineHeight: "18px",
                  },
                }
                : {
                  "& .MuiTableCell-root": {
                    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                    fontSize: "13px",
                    fontWeight: 500,
                    lineHeight: "16px",
                    backgroundColor: "#f5f5f5",
                    color: "#000000",
                  },
                  "& .MuiTableRow-root": {
                    height: "36px",
                    "&:hover": {
                      backgroundColor: "#f0f0f0",
                    },
                  },
                  "& .MuiTableHead-root .MuiTableCell-root": {
                    fontSize: "13px",
                    lineHeight: "18px",
                  },
                },
            }}
            muiTopToolbarProps={{
              sx: darkMode
                ? {
                  color: "#ffffff",
                  "& svg": { color: "#ffffff" },
                  padding: "6px 8px",
                }
                : { backgroundColor: "#f5f5f5", padding: "6px 8px" },
            }}
            muiTableBodyProps={{
              sx: darkMode ? { color: "#ffffff" } : { color: "#000000" },
            }}
            muiTableHeadCellProps={{
              sx: darkMode
                ? { color: "#ffffff" }
                : { backgroundColor: "#f5f5f5" },
            }}
            muiBottomToolbarProps={{
              sx: darkMode
                ? {
                  color: "#ffffff",
                  "& p,button,div": {
                    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                    fontWeight: 500,
                  },
                  padding: "6px 8px",
                }
                : { backgroundColor: "#f5f5f5", padding: "6px 8px" },
            }}
            muiTableBodyCellProps={{
              sx: {
                borderBottom: "1px solid #e0e0e0",
                "& *": { lineHeight: "16px" },
              },
            }}
            renderEmptyRowsFallback={() => (
              <div
                style={{
                  textAlign: "center",
                  // padding: "12px",
                  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
                  fontSize: "13px",
                  fontWeight: "500",
                  color: darkMode ? "#ffffff" : "#000000",
                }}
              >
                No records to display
              </div>
            )}
          />
        )}
      </Card>
    </Drawer>
  );
};

export default DashboardDrawer;
